import dayjs from "global/dayjs";
import { dayjsLocalizer } from "react-big-calendar";

export const useLocalizer = () => dayjsLocalizer(dayjs);
